import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { canView, landingRoute } from '@/constants/permissions';
import { ROUTES } from '@/constants/routes';
import { useAuthStore } from '@/stores/authStore';

interface ProtectedRouteProps {
  permission: string;
  children: ReactNode;
}

export function ProtectedRoute({ permission, children }: ProtectedRouteProps) {
  const admin = useAuthStore((state) => state.admin);

  if (!admin) {
    return <Navigate to={ROUTES.login} replace />;
  }

  if (!canView(admin, permission)) {
    return <Navigate to={landingRoute(admin)} replace />;
  }

  return <>{children}</>;
}
